import { PlanSummary } from 'types/app';

// list of all current plans
export const plans: PlanSummary[] = [
  // Running Plans
  ['5k-beginner', '5k Beginner', '5K'],
  ['5k-intermediate', '5k Intermediate', '5K'],
  ['5k-advanced', '5k Advanced', '5K'],
  ['5k-elite', '5k Elite', '5K'],
  ['10k-beginner', '10k Beginner', '10K'],
  ['10k-intermediate', '10k Intermediate', '10K'],
  ['10k-advanced', '10k Advanced', '10K'],
  ['10k-elite', '10k Elite', '10K'],
  ['half-beginner', 'Half-Marathon Beginner', 'Half Marathon'],
  ['half-intermediate', 'Half-Marathon Intermediate', 'Half Marathon'],
  ['half-advanced', 'Half-Marathon Advanced', 'Half Marathon'],
  ['half-elite', 'Half-Marathon Elite', 'Half Marathon'],
  ['marathon-beginner', 'Marathon Beginner', 'Marathon'],
  ['marathon-intermediate', 'Marathon Intermediate', 'Marathon'],
  ['marathon-advanced', 'Marathon Advanced', 'Marathon'],
  ['marathon-elite', 'Marathon Elite', 'Marathon'],

  // Swimming Plans
  ['50m-beginner', '50m Beginner', '50m'],
  ['50m-intermediate', '50m Intermediate', '50m'],
  ['50m-advanced', '50m Advanced', '50m'],
  ['50m-elite', '50m Elite', '50m'],
  ['100m-beginner', '100m Beginner', '100m'],
  ['100m-intermediate', '100m Intermediate', '100m'],
  ['100m-advanced', '100m Advanced', '100m'],
  ['100m-elite', '100m Elite', '100m'],
  ['400m-beginner', '400m Beginner', '400m'],
  ['400m-intermediate', '400m Intermediate', '400m'],
  ['400m-advanced', '400m Advanced', '400m'],
  ['400m-elite', '400m Elite', '400m'],
  ['1500m-beginner', '1500m Beginner', '1500m'],
  ['1500m-intermediate', '1500m Intermediate', '1500m'],
  ['1500m-advanced', '1500m Advanced', '1500m'],
  ['1500m-elite', '1500m Elite', '1500m'],
  ['5km-beginner', '5km Swim Beginner', '5km Swim'],
  ['5km-intermediate', '5km Swim Intermediate', '5km Swim'],
  ['5km-advanced', '5km Swim Advanced', '5km Swim'],
  ['5km-elite', '5km Swim Elite', '5km Swim'],
  ['10km-beginner', '10km Swim Beginner', '10km Swim'],
  ['10km-intermediate', '10km Swim Intermediate', '10km Swim'],
  ['10km-advanced', '10km Swim Advanced', '10km Swim'],
  ['10km-elite', '10km Swim Elite', '10km Swim'],

  // Cycling Plans
  ['20km-beginner', '20km Ride Beginner', '20km Ride'],
  ['20km-intermediate', '20km Ride Intermediate', '20km Ride'],
  ['20km-advanced', '20km Ride Advanced', '20km Ride'],
  ['20km-elite', '20km Ride Elite', '20km Ride'],
  ['40km-beginner', '40km Ride Beginner', '40km Ride'],
  ['40km-intermediate', '40km Ride Intermediate', '40km Ride'],
  ['40km-advanced', '40km Ride Advanced', '40km Ride'],
  ['40km-elite', '40km Ride Elite', '40km Ride'],
  ['80km-beginner', '80km Ride Beginner', '80km Ride'],
  ['80km-intermediate', '80km Ride Intermediate', '80km Ride'],
  ['80km-advanced', '80km Ride Advanced', '80km Ride'],
  ['80km-elite', '80km Ride Elite', '80km Ride'],
  ['100km-beginner', '100km Ride Beginner', '100km Ride'],
  ['100km-intermediate', '100km Ride Intermediate', '100km Ride'],
  ['100km-advanced', '100km Ride Advanced', '100km Ride'],
  ['100km-elite', '100km Ride Elite', '100km Ride'],
  ['160km-beginner', '160km Ride Beginner', '160km Ride'],
  ['160km-intermediate', '160km Ride Intermediate', '160km Ride'],
  ['160km-advanced', '160km Ride Advanced', '160km Ride'],
  ['160km-elite', '160km Ride Elite', '160km Ride'],

  // Hyrox Plans
  ['women-open-beginner', 'Hyrox Women Open Beginner', 'Hyrox Women Open'],
  [
    'women-open-intermediate',
    'Hyrox Women Open Intermediate',
    'Hyrox Women Open',
  ],
  ['women-open-advanced', 'Hyrox Women Open Advanced', 'Hyrox Women Open'],
  ['women-open-elite', 'Hyrox Women Open Elite', 'Hyrox Women Open'],
  ['women-pro-beginner', 'Hyrox Women Pro Beginner', 'Hyrox Women Pro'],
  ['women-pro-intermediate', 'Hyrox Women Pro Intermediate', 'Hyrox Women Pro'],
  ['women-pro-advanced', 'Hyrox Women Pro Advanced', 'Hyrox Women Pro'],
  ['women-pro-elite', 'Hyrox Women Pro Elite', 'Hyrox Women Pro'],
  ['men-open-beginner', 'Hyrox Men Open Beginner', 'Hyrox Men Open'],
  ['men-open-intermediate', 'Hyrox Men Open Intermediate', 'Hyrox Men Open'],
  ['men-open-advanced', 'Hyrox Men Open Advanced', 'Hyrox Men Open'],
  ['men-open-elite', 'Hyrox Men Open Elite', 'Hyrox Men Open'],
  ['men-pro-beginner', 'Hyrox Men Pro Beginner', 'Hyrox Men Pro'],
  ['men-pro-intermediate', 'Hyrox Men Pro Intermediate', 'Hyrox Men Pro'],
  ['men-pro-advanced', 'Hyrox Men Pro Advanced', 'Hyrox Men Pro'],
  ['men-pro-elite', 'Hyrox Men Pro Elite', 'Hyrox Men Pro'],

  // Triathlon Plans
  ['sprint-beginner', 'Sprint Triathlon Beginner', 'Sprint Triathlon'],
  ['sprint-intermediate', 'Sprint Triathlon Intermediate', 'Sprint Triathlon'],
  ['sprint-advanced', 'Sprint Triathlon Advanced', 'Sprint Triathlon'],
  ['sprint-elite', 'Sprint Triathlon Elite', 'Sprint Triathlon'],
  ['standard-beginner', 'Standard Triathlon Beginner', 'Standard Triathlon'],
  [
    'standard-intermediate',
    'Standard Triathlon Intermediate',
    'Standard Triathlon',
  ],
  ['standard-advanced', 'Standard Triathlon Advanced', 'Standard Triathlon'],
  ['standard-elite', 'Standard Triathlon Elite', 'Standard Triathlon'],
  ['half-ironman-beginner', 'Half Ironman Beginner', 'Half Ironman'],
  ['half-ironman-intermediate', 'Half Ironman Intermediate', 'Half Ironman'],
  ['half-ironman-advanced', 'Half Ironman Advanced', 'Half Ironman'],
  ['half-ironman-elite', 'Half Ironman Elite', 'Half Ironman'],
  ['ironman-beginner', 'Ironman Beginner', 'Ironman'],
  ['ironman-intermediate', 'Ironman Intermediate', 'Ironman'],
  ['ironman-advanced', 'Ironman Advanced', 'Ironman'],
  ['ironman-elite', 'Ironman Elite', 'Ironman'],

  // ["c25k", "Couch to 5K", "5K"],
  // ["c25k_rbp", "Couch to 5K -- Runner's Blueprint", "5K"],
  // ["frr_5k_01", "Faster Road Racing: 5K Schedule 1", "5K"],
  // ["frr_5k_02", "Faster Road Racing: 5K Schedule 2", "5K"],
  // ["frr_5k_03", "Faster Road Racing: 5K Schedule 3", "5K"],
  // ["frr_8k10k_01", "Faster Road Racing: 8K-10K Schedule 1", "10K"],
  // ["frr_8k10k_02", "Faster Road Racing: 8K-10K Schedule 2", "10K"],
  // ["frr_8k10k_03", "Faster Road Racing: 8K-10K Schedule 3", "10K"],
  // [
  //   "frr_15k_10m_01",
  //   "Faster Road Racing: 15k and 10 Miles Schedule 1",
  //   "15K/10M",
  // ],
  // [
  //   "frr_15k_10m_02",
  //   "Faster Road Racing: 15k and 10 Miles Schedule 2",
  //   "15K/10M",
  // ],
  // [
  //   "frr_15k_10m_03",
  //   "Faster Road Racing: 15k and 10 Miles Schedule 3",
  //   "15K/10M",
  // ],
  // ["frr_bt_01", "Faster Road Racing: Base Training 1", "Base"],
  // ["frr_bt_02", "Faster Road Racing: Base Training 2", "Base"],
  // ["frr_bt_03", "Faster Road Racing: Base Training 3", "Base"],
  // [
  //   "frr_multiple_distances_01",
  //   "Faster Road Racing: Multiple Distances 1",
  //   "Multiple Distances",
  // ],
  // [
  //   "frr_multiple_distances_02",
  //   "Faster Road Racing: Multiple Distances 2",
  //   "Multiple Distances",
  // ],
  // [
  //   "frr_multiple_distances_03",
  //   "Faster Road Racing: Multiple Distances 3",
  //   "Multiple Distances",
  // ],
  // [
  //   "pfitz_half_12_47",
  //   "Faster Road Racing: Half Marathon Schedule 1, 31 to 47 miles per Week",
  //   "Half Marathon",
  // ],
  // [
  //   "pfitz_half_12_63",
  //   "Faster Road Racing: Half Marathon Schedule 2, 46 to 63 miles per Week",
  //   "Half Marathon",
  // ],
  // [
  //   "pfitz_half_12_84",
  //   "Faster Road Racing: Half Marathon Schedule 3, 61 to 84 miles per Week",
  //   "Half Marathon",
  // ],
  // [
  //   "pfitz_half_12_100",
  //   "Faster Road Racing: Half Marathon Schedule 4, 81 to 100 miles per Week",
  //   "Half Marathon",
  // ],
  // ["hansons_c210k", "Hansons Couch Potato to 10k", "10K"],
  // ["hansons_adv_half", "Hansons Advanced Half Marathon", "Half Marathon"],
  // ["hansons_beg_half", "Hansons Beginner Half Marathon", "Half Marathon"],
  // ["higdon_adv_mara1", "Hal Higdon: Advanced 1", "Marathon"],
  // ["higdon_adv_mara2", "Hal Higdon: Advanced 2", "Marathon"],
  // ["higdon_int_mara1", "Hal Higdon: Intermediate 1", "Marathon"],
  // ["higdon_int_mara2", "Hal Higdon: Intermediate 2", "Marathon"],
  // ["higdon_nov_mara1", "Hal Higdon: Novice 1", "Marathon"],
  // ["higdon_nov_mara2", "Hal Higdon: Novice 2", "Marathon"],
  // ["higdon_mara3", "Hal Higdon: Marathon 3", "Marathon"],
  // ["higdon_senior_mara", "Hal Higdon: Senior Marathon", "Marathon"],
  // ["higdon_half3", "Hal Higdon: Half Marathon 3", "Half Marathon"],
  // [
  //   "higdon_int_half1",
  //   "Hal Higdon: Half Marathon Intermediate 1",
  //   "Half Marathon",
  // ],
  // [
  //   "higdon_int_half2",
  //   "Hal Higdon: Half Marathon Intermediate 2",
  //   "Half Marathon",
  // ],
  // ["higdon_nov_half1", "Hal Higdon: Half Marathon Novice 1", "Half Marathon"],
  // ["higdon_nov_half2", "Hal Higdon: Half Marathon Novice 2", "Half Marathon"],
  // ["hansons_adv_mara", "Hansons Advanced Marathon", "Marathon"],
  // ["hansons_beg_mara", "Hansons Beginner Marathon", "Marathon"],
  // [
  //   "coogan_pbr_mara_up_to_65",
  //   "Personal Best Running: 16-Week Marathon - Up to 65 Miles per Week",
  //   "Marathon",
  // ],
  // ["boston_level_one", "Boston Marathon Level 1 Plan", "Marathon"],
  // ["boston_level_two", "Boston Marathon Level 2 Plan", "Marathon"],
  // ["boston_level_three", "Boston Marathon Level 3 Plan", "Marathon"],
  // ["boston_level_four", "Boston Marathon Level 4 Plan", "Marathon"],
  // [
  //   "pfitz_12_55",
  //   "Pfitzinger/Douglas: Up to 55 miles per week, 12-week schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_12_55_4th",
  //   "Pfitzinger/Douglas: Up to 55 miles per week, 12-week schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_12_70",
  //   "Pfitzinger/Douglas: 55 to 70 Miles per Week, 12-week schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_12_70_4th",
  //   "Pfitzinger/Douglas: 55 to 70 Miles per Week, 12-week schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_12_85",
  //   "Pfitzinger/Douglas: 70 to 85 Miles per Week, 12-week schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_12_85_4th",
  //   "Pfitzinger/Douglas: 70 to 85 Miles per Week, 12-week schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_12_more_than_85",
  //   "Pfitzinger/Douglas: More Than 85 Miles per Week, 12-week schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_12_more_than_85_4th",
  //   "Pfitzinger/Douglas: More Than 85 Miles per Week, 12-week schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_18_55",
  //   "Pfitzinger/Douglas: Up to 55 miles per week, 18-week schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_18_55_4th",
  //   "Pfitzinger/Douglas: Up to 55 miles per week, 18-week schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_18_70",
  //   "Pfitzinger/Douglas: 55 to 70 Miles per Week, 18-week schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_18_70_4th",
  //   "Pfitzinger/Douglas: 55 to 70 Miles per Week, 18-week schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_18_85",
  //   "Pfitzinger/Douglas: 70 to 85 Miles per Week, 18-week schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_18_85_4th",
  //   "Pfitzinger/Douglas: 70 to 85 Miles per Week, 18-week schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_18_more_than_85",
  //   "Pfitzinger/Douglas: More Than 85 Miles per Week, 18-week schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_18_more_than_85_4th",
  //   "Pfitzinger/Douglas: More Than 85 Miles per Week, 18-week schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_04_multi",
  //   "Pfitzinger/Douglas: Multiple Marathoning, 4-Week Schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_04_multi_4th",
  //   "Pfitzinger/Douglas: Multiple Marathoning, 4-Week Schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_06_multi",
  //   "Pfitzinger/Douglas: Multiple Marathoning, 6-Week Schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_06_multi_4th",
  //   "Pfitzinger/Douglas: Multiple Marathoning, 6-Week Schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_08_multi",
  //   "Pfitzinger/Douglas: Multiple Marathoning, 8-Week Schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_08_multi_4th",
  //   "Pfitzinger/Douglas: Multiple Marathoning, 8-Week Schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_10_multi",
  //   "Pfitzinger/Douglas: Multiple Marathoning, 10-Week Schedule (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_10_multi_4th",
  //   "Pfitzinger/Douglas: Multiple Marathoning, 10-Week Schedule (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_55_recovery",
  //   "Pfitzinger/Douglas: Marathon Up to 55 Miles per Week Recovery (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_55_recovery_4th",
  //   "Pfitzinger/Douglas: Marathon Up to 55 Miles per Week Recovery (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_70_recovery",
  //   "Pfitzinger/Douglas: Marathon 55 to 70 Miles per Week Recovery (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_70_recovery_4th",
  //   "Pfitzinger/Douglas: Marathon 55 to 70 Miles per Week Recovery (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_85_recovery",
  //   "Pfitzinger/Douglas: Marathon 70 to 85 Miles per Week Recovery (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_85_recovery_4th",
  //   "Pfitzinger/Douglas: Marathon 70 to 85 Miles per Week Recovery (fourth edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_more_than_85_recovery",
  //   "Pfitzinger/Douglas: Marathon More Than 85 Miles per Week Recovery (third edition)",
  //   "Marathon",
  // ],
  // [
  //   "pfitz_more_than_85_recovery_4th",
  //   "Pfitzinger/Douglas: Marathon More Than 85 Miles per Week Recovery (fourth edition)",
  //   "Marathon",
  // ],
];
